exports.init = function AutoOpenModal() {
  const modals = $('.js-auto-open-modal');

  modals.on('show.bs.modal', function () {
    if (!this.classList.contains('js-modal-no-history')) {
      location.hash = this.id;
    }
  });

  modals.on('hide.bs.modal', function () {
    location.hash = '';
  });

  if (location.hash.length) {
    modals.filter(location.hash).modal('show');
  }

  window.addEventListener('hashchange', modalHashChangeHandler);
}

function modalHashChangeHandler() {
  const hash = location.hash;
  if (hash) {
    const modal = $(hash);
    if (modal.length
      && modal.hasClass('modal')
      && !modal.hasClass('in')
      && !modal.hasClass('js-modal-no-history')) {
      modal.modal('show');
    }
  } else {
    const modal = $('.modal.show.js-auto-open-modal');
    modal.modal('hide');
  }
}

